import camelCase from 'camelcase-keys';
export var transformQueryToCamelCase = function transformQueryToCamelCase(query) {
  return camelCase(query, {
    deep: true
  });
};